<template>
  <user-profile-preferences-form></user-profile-preferences-form>
</template>

<script>
import UserProfilePreferencesForm from '../../_components/profile/UserPreferencesForm'
export default {
  name: 'UserProfilePreferencesIndex',
  components: { UserProfilePreferencesForm }
}
</script>

<style>

</style>
